import type { RoadmapPhase } from '@/store/projectStore';
import { phaseLabelFromMeta, roadmapPhasesSorted } from '@/store/projectStore';

/** Fallback для миграции и старых подписей (до динамических этапов). */
export const PHASE_OPTIONS = [
  { value: '1' as const, label: 'Этап 1 — Q2 2026', phaseNum: 1 as const },
  { value: '2' as const, label: 'Этап 2 — Q2–Q4 2026', phaseNum: 2 as const },
  { value: '3' as const, label: 'Этап 3 — Q4 2026 – Q2 2027', phaseNum: 3 as const },
] as const;

export type PhaseSelectValue = (typeof PHASE_OPTIONS)[number]['value'];

export function phaseLabelFor(phase: 1 | 2 | 3): string {
  const row = PHASE_OPTIONS.find((o) => o.phaseNum === phase);
  return row?.label ?? PHASE_OPTIONS[0].label;
}

/** Опции селектора этапа из workspace (`roadmapPhases`). */
export function phaseOptionsFromRoadmap(phases: RoadmapPhase[]): { value: string; label: string }[] {
  return roadmapPhasesSorted(phases).map((p) => ({
    value: p.id,
    label: phaseLabelFromMeta(p),
  }));
}
